export default class UnclaimedSessionOverError extends Error {
    forceSignOut;
    constructor() {
        super('Unclaimed session has ended');
        this.forceSignOut = true;
    }
}
